import { render, staticRenderFns } from "./resultsDefault.vue?vue&type=template&id=30a1d51f"
import script from "./resultsDefault.vue?vue&type=script&lang=js"
export * from "./resultsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports